import React from 'react';
import { IconProps } from '../types/types';

const GETH: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" role="img" {...props}><path fill="#7190EB" d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Z"/><path fill="#fff" d="M16.32 4.817a.116.116 0 0 0-.023-.06.106.106 0 0 0-.053-.033l-6.22-1.563a.095.095 0 0 0-.047 0L3.758 4.724a.106.106 0 0 0-.053.033.11.11 0 0 0-.023.059c-.01.105-.764 10.71 6.285 13.18a.09.09 0 0 0 .064 0c7.051-2.468 6.297-13.073 6.29-13.178ZM9.994 6.02l2.682 4.539-2.682 1.57-2.67-1.57 2.67-4.54Zm0 9.129L7.2 11.2l2.795 1.666L12.8 11.2l-2.805 3.948Z"/></svg>
);

export default GETH;
